import React from "../../../_snowpack/pkg/react.js";
import Button from "../../../_snowpack/pkg/react-bootstrap/Button.js";
import Card from "../../../_snowpack/pkg/react-bootstrap/Card.js";
import GitHubIcon from "../../Assets/github_icon.png";
import LinkedInIcon from "../../Assets/linkedin_icon.png";
import RockyCoast from "../../Assets/rocks-1061540_1920.jpg";
import SunriseVideo from "../../Assets/sunrise_coast.mp4";
import styles from "./HomePage.module.css";
const HomePage = () => {
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.bodyContainer
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.homeVideoContainer
  }, /* @__PURE__ */ React.createElement("video", {
    className: styles.homeVideo,
    src: SunriseVideo,
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true
  })), /* @__PURE__ */ React.createElement("div", {
    className: styles.headerContainer
  }, /* @__PURE__ */ React.createElement("h1", {
    className: styles.header
  }, " Welcome!")), /* @__PURE__ */ React.createElement("div", {
    className: styles.bodyContainer
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.bodyTextContainer
  }, /* @__PURE__ */ React.createElement("p", {
    className: styles.bodyText
  }, "I’m a full-stack developer with experience in Python, Java, and React Native. Need help designing your website, app, or even database? Take a look at my work and see if my expertise is right for you.")), /* @__PURE__ */ React.createElement("div", {
    className: styles.cardContainer
  }, /* @__PURE__ */ React.createElement(Card, {
    className: styles.card
  }, /* @__PURE__ */ React.createElement(Card.Img, {
    variant: "top",
    src: LinkedInIcon
  }), /* @__PURE__ */ React.createElement(Card.Body, null, /* @__PURE__ */ React.createElement(Card.Title, null, "LinkedIn"), /* @__PURE__ */ React.createElement(Card.Text, null, "Check out my LinkedIn profile and feel free to reach out!"), /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    href: "https://www.linkedin.com/in/munshi-nadim-a31614267/"
  }, "Go to LinkedIn"))), /* @__PURE__ */ React.createElement(Card, {
    className: styles.card
  }, /* @__PURE__ */ React.createElement(Card.Img, {
    variant: "top",
    src: GitHubIcon
  }), /* @__PURE__ */ React.createElement(Card.Body, null, /* @__PURE__ */ React.createElement(Card.Title, null, "GitHub"), /* @__PURE__ */ React.createElement(Card.Text, null, "Check out my GitHub profile and all the projects I have yet to create!"), /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    href: "https://github.com/nmunshii"
  }, "Go to Github"))), /* @__PURE__ */ React.createElement(Card, {
    className: styles.card
  }, /* @__PURE__ */ React.createElement(Card.Img, {
    variant: "top",
    src: RockyCoast,
    className: styles.cardImg
  }), /* @__PURE__ */ React.createElement(Card.Body, null, /* @__PURE__ */ React.createElement(Card.Title, null, "About Me"), /* @__PURE__ */ React.createElement(Card.Text, null, "Check out more about me!"), /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    href: "/about-me"
  }, "Click Me!"))))));
};
export default HomePage;
